import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMeetingListForChart } from "../../redux/actions/meetingActions/MeetingAction";
import MeetingBar from "./MeetingBar";
import MeetingPieChart from "./MeetingPieChart";
const MeetingDetailsPieChart = React.memo(
  ({ data, totalCount, organizationId }) => {
    const meetingData = useSelector((state) => state.meeting);
    const [updatedDatas, setUpdatedDatas] = useState([]);
    const [finalMeetingDatas, setFinalMeetingDatas] = useState([]);
    const accessToken = localStorage.getItem("accessToken");
    const dispatch = useDispatch();

    useEffect(() => {
      if (accessToken) {
        dispatch(getMeetingListForChart(organizationId, accessToken));
      }
    }, [meetingData.isFetchedMeetingList]);

    useEffect(() => {
      const updatedData = [
        {
          id: 0,
          value:
            meetingData?.meetingChartDetails?.totalCount === 0
              ? 0
              : normalize(
                  meetingData?.meetingChartDetails?.scheduled,
                  meetingData?.meetingChartDetails?.totalCount
                ),
          count: meetingData?.meetingChartDetails?.scheduled,
          label: "Scheduled",

          name: `Scheduled (${
            meetingData?.meetingChartDetails?.scheduled
              ? meetingData?.meetingChartDetails?.scheduled
              : 0
          })`,
          color: "#2796f3",
        },
        {
          id: 1,

          name: `Rescheduled (${
            meetingData?.meetingChartDetails?.rescheduled
              ? meetingData?.meetingChartDetails?.rescheduled
              : 0
          })`,
          value:
            meetingData?.meetingChartDetails?.totalCount === 0
              ? 0
              : normalize(
                  meetingData?.meetingChartDetails?.rescheduled,
                  meetingData?.meetingChartDetails?.totalCount
                ),
          count: meetingData?.meetingChartDetails?.rescheduled,
          label: "Rescheduled",
          color: "#ab47bc",
        },
        {
          id: 2,

          name: `Closed (${
            meetingData?.meetingChartDetails?.closed
              ? meetingData?.meetingChartDetails?.closed
              : 0
          })`,
          value:
            meetingData?.meetingChartDetails?.totalCount === 0
              ? 0
              : normalize(
                  meetingData?.meetingChartDetails?.closed,
                  meetingData?.meetingChartDetails?.totalCount
                ),
          count: meetingData?.meetingChartDetails?.closed,
          label: "Closed",
          color: "#4caf50",
        },

        {
          id: 4,

          name: `Cancelled (${
            meetingData?.meetingChartDetails?.cancelled
              ? meetingData?.meetingChartDetails?.cancelled
              : 0
          })`,
          count: meetingData?.meetingChartDetails?.cancelled,
          value:
            meetingData?.meetingChartDetails?.totalCount === 0
              ? 0
              : normalize(
                  meetingData?.meetingChartDetails?.cancelled,
                  meetingData?.meetingChartDetails?.totalCount
                ),
          label: "Cancelled",
          color: "#f83e6a",
        },
      ];

      if (
        meetingData?.meetingChartDetails === null ||
        ((meetingData?.meetingChartDetails?.totalCount === 0 ||
          meetingData?.meetingChartDetails?.totalCount === undefined) &&
          meetingData?.meetingChartDetails?.draft === 0)
      ) {
        updatedData.push({
          id: 5,

          name: "No Meetings",
          value: 100,
          count: 0,
          label: "No Meetings",
          color: "#5b7197",
        });
      }

      if (
        meetingData?.meetingChartDetails?.totalCount === 0 &&
        meetingData?.totalCount !== 0 &&
        meetingData?.meetingChartDetails?.cancelled === 0 &&
        meetingData?.meetingChartDetails?.closed === 0 &&
        meetingData?.meetingChartDetails?.rescheduled === 0 &&
        meetingData?.meetingChartDetails?.scheduled === 0 &&
        meetingData?.meetingChartDetails?.draft !== 0
      ) {
        updatedData.push({
          id: 3,
          name: `Draft(${
            meetingData?.meetingChartDetails?.draft
              ? meetingData?.meetingChartDetails?.draft
              : 0
          })`,
          color: "#9E9E9E",
          value:
            meetingData?.totalCount === 0
              ? 0
              : normalize(
                  meetingData?.meetingChartDetails?.draft,
                  meetingData?.totalCount
                ),
          count: meetingData?.meetingChartDetails?.draft,
          label: "Draft",
        });
      }

      setFinalMeetingDatas(updatedData);
    }, [
      meetingData?.meetingChartDetails,
      meetingData?.totalCount,
      meetingData?.meetingList,
    ]);

    useEffect(() => {
      const updatedData = [
        {
          id: 0,
          value:
            data?.length === 0
              ? 0
              : normalize(
                  data?.filter(
                    (meeting) => meeting?.meetingStatus?.status === "scheduled"
                  ).length,
                  data?.length
                ),
          count: data?.filter(
            (meeting) => meeting?.meetingStatus?.status === "scheduled"
          ).length,
          label: "Scheduled",
          name: "Scheduled",
          color: "#2196F3",
        },
        {
          id: 1,
          value:
            data?.length === 0
              ? 0
              : normalize(
                  data?.filter(
                    (meeting) =>
                      meeting?.meetingStatus?.status === "rescheduled"
                  ).length,
                  data?.length
                ),
          count: data?.filter(
            (meeting) => meeting?.meetingStatus?.status === "rescheduled"
          ).length,
          label: "Rescheduled",
          color: "#AB47BC",
          name: "Rescheduled",
        },
        {
          id: 2,
          value:
            data?.length === 0
              ? 0
              : normalize(
                  data?.filter(
                    (meeting) => meeting?.meetingStatus?.status === "closed"
                  ).length,
                  data?.length
                ),
          count: data?.filter(
            (meeting) => meeting?.meetingStatus?.status === "closed"
          ).length,
          label: "Closed",
          color: "#4CAF50",
          name: "Closed",
        },
        {
          id: 3,
          value:
            data?.length === 0
              ? 0
              : normalize(
                  data?.filter(
                    (meeting) => meeting?.meetingStatus?.status === "draft"
                  ).length,
                  data?.length
                ),
          count: data?.filter(
            (meeting) => meeting?.meetingStatus?.status === "draft"
          ).length,
          label: "Draft",
          color: "#9E9E9E",
          name: "Draft",
        },
        {
          id: 4,
          value:
            data?.length === 0
              ? 0
              : normalize(
                  data?.filter(
                    (meeting) => meeting?.meetingStatus?.status === "cancelled"
                  ).length,
                  data?.length
                ),
          count: data?.filter(
            (meeting) => meeting?.meetingStatus?.status === "cancelled"
          ).length,
          label: "Cancelled",
          color: "#f83e6a",
          name: "Cancelled",
        },
        {
          id: 5,
          value:
            data?.length === 0
              ? 100
              : normalize(
                  data?.length === 0 ? 1 : 0,
                  data?.length === 0 ? 1 : data?.length
                ),
          count: 0,
          label: "No Meetings",
          color: "#5b7197",
          name: "No Meetings",
        },
      ];
      setUpdatedDatas(updatedData);
    }, [data]);

    const normalize = (v, v2) => Number.parseFloat(((v / v2) * 100).toFixed(2));

    return (
      <div className="color-box-resp">
        <div className="row">
          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 ">
            <div className="mt-2 table-box responsive-table chart-min">
              <h6>Total Meetings</h6>

              <MeetingPieChart
                data={finalMeetingDatas}
                totalCount={totalCount}
                organizationId={organizationId}
              />
            </div>
          </div>
          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 resp-mt-2 ">
            <div className="table-box responsive-table res-mt-20 due-action-table">
              <MeetingBar showDetailsLink={true} />
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default MeetingDetailsPieChart;
